import React, { useState } from 'react';
import { LayoutDashboardIcon, FileTextIcon, BarChartIcon, SettingsIcon, LogOutIcon, SearchIcon, CheckCircleIcon, ClockIcon, XCircleIcon, UserIcon, MenuIcon, EyeIcon, DatabaseIcon, ArrowLeftIcon, MapPinIcon, ShieldCheckIcon, AlertCircleIcon, CreditCardIcon, MapIcon, HistoryIcon, GavelIcon, BuildingIcon, UploadIcon, PlusIcon } from 'lucide-react';
// Enhanced Sample Data
const sampleApplications = [{
  id: 'APP-2026-001',
  applicant: 'মো. রহিম উদ্দিন',
  fatherName: 'মৃত আব্দুল জব্বার',
  nid: '১৯৮৫২৬৯৮৭৪৫১২',
  division: 'ঢাকা',
  district: 'ঢাকা',
  upazila: 'মিরপুর',
  mouza: 'জাঁতুলিয়া',
  address: 'মিরপুর, ঢাকা',
  khatian: '১০২৩',
  dagNo: '৪৫৬',
  area: '০.৪৫',
  landType: 'কৃষি',
  ownershipType: 'ক্রয়সূত্রে',
  surveyType: 'বিআরএস',
  mutationStatus: 'completed',
  taxStatus: 'paid',
  date: '১২ মার্চ ২০২৬',
  status: 'approved'
}, {
  id: 'APP-2026-002',
  applicant: 'আব্দুল করিম',
  fatherName: 'মৃত সোবহান আলী',
  nid: '১৯৭৮২৬৯৮৭৪৫১৩',
  division: 'ঢাকা',
  district: 'ঢাকা',
  upazila: 'পল্লবী',
  mouza: 'পল্লবী',
  address: 'পল্লবী, ঢাকা',
  khatian: '১০২৪',
  dagNo: '৪৫৭',
  area: '০.৩০',
  landType: 'আবাসিক',
  ownershipType: 'উত্তরাধিকার',
  surveyType: 'বিআরএস',
  mutationStatus: 'pending',
  taxStatus: 'unpaid',
  date: '১১ মার্চ ২০২৬',
  status: 'pending'
}, {
  id: 'APP-2026-003',
  applicant: 'ফাতেমা বেগম',
  fatherName: 'মৃত হাসেম আলী',
  nid: '১৯৯০২৬৯৮৭৪৫১৪',
  division: 'ঢাকা',
  district: 'গাজীপুর',
  upazila: 'কালিয়াকৈর',
  mouza: 'কালিয়াকৈর',
  address: 'কালিয়াকৈর, গাজীপুর',
  khatian: '১০২৫',
  dagNo: '৪৫৮',
  area: '১.২০',
  landType: 'কৃষি',
  ownershipType: 'ক্রয়সূত্রে',
  surveyType: 'বিআরএস',
  mutationStatus: 'completed',
  taxStatus: 'paid',
  date: '১০ মার্চ ২০২৬',
  status: 'approved'
}, {
  id: 'APP-2026-004',
  applicant: 'মো. জামাল হোসেন',
  fatherName: 'মৃত কামাল হোসেন',
  nid: '১৯৮২২৬৯৮৭৪৫১৫',
  division: 'চট্টগ্রাম',
  district: 'চট্টগ্রাম',
  upazila: 'পটিয়া',
  mouza: 'পটিয়া',
  address: 'পটিয়া, চট্টগ্রাম',
  khatian: '১০২৬',
  dagNo: '৪৫৯',
  area: '০.৮০',
  landType: 'বাণিজ্যিক',
  ownershipType: 'ক্রয়সূত্রে',
  surveyType: 'বিআরএস',
  mutationStatus: 'completed',
  taxStatus: 'paid',
  date: '০৯ মার্চ ২০২৬',
  status: 'rejected'
}, {
  id: 'APP-2026-005',
  applicant: 'আবু তাহের আলী',
  fatherName: 'মৃত আকবর আলী',
  nid: '১৯৭৫২৬৯৮৭৪৫১৬',
  division: 'রাজশাহী',
  district: 'রাজশাহী',
  upazila: 'পবা',
  mouza: 'পবা',
  address: 'পবা, রাজশাহী',
  khatian: '১০২৭',
  dagNo: '৪৬০',
  area: '২.৫০',
  landType: 'কৃষি',
  ownershipType: 'উত্তরাধিকার',
  surveyType: 'বিআরএস',
  mutationStatus: 'pending',
  taxStatus: 'paid',
  date: '০৮ মার্চ ২০২৬',
  status: 'pending'
}, {
  id: 'APP-2026-006',
  applicant: 'নূর মোহাম্মদ',
  fatherName: 'মৃত গোলাম মোস্তফা',
  nid: '১৯৮৮২৬৯৮৭৪৫১৭',
  division: 'ঢাকা',
  district: 'নারায়ণগঞ্জ',
  upazila: 'সোনারগাঁও',
  mouza: 'সোনারগাঁও',
  address: 'সোনারগাঁও, নারায়ণগঞ্জ',
  khatian: '১০২৮',
  dagNo: '৪৬১',
  area: '০.৬০',
  landType: 'আবাসিক',
  ownershipType: 'ক্রয়সূত্রে',
  surveyType: 'বিআরএস',
  mutationStatus: 'completed',
  taxStatus: 'paid',
  date: '০৭ মার্চ ২০২৬',
  status: 'approved'
}, {
  id: 'APP-2026-007',
  applicant: 'সালমা আক্তার',
  fatherName: 'মৃত রফিকুল ইসলাম',
  nid: '১৯৯২২৬৯৮৭৪৫১৮',
  division: 'খুলনা',
  district: 'খুলনা',
  upazila: 'দৌলতপুর',
  mouza: 'দৌলতপুর',
  address: 'দৌলতপুর, খুলনা',
  khatian: '১০২৯',
  dagNo: '৪৬২',
  area: '০.৪০',
  landType: 'আবাসিক',
  ownershipType: 'উত্তরাধিকার',
  surveyType: 'বিআরএস',
  mutationStatus: 'pending',
  taxStatus: 'unpaid',
  date: '০৬ মার্চ ২০২৬',
  status: 'pending'
}, {
  id: 'APP-2026-008',
  applicant: 'মো. কামরুল ইসলাম',
  fatherName: 'মৃত শফিকুল ইসলাম',
  nid: '১৯৮০২৬৯৮৭৪৫১৯',
  division: 'সিলেট',
  district: 'সিলেট',
  upazila: 'বিশ্বনাথ',
  mouza: 'বিশ্বনাথ',
  address: 'বিশ্বনাথ, সিলেট',
  khatian: '১০৩০',
  dagNo: '৪৬৩',
  area: '১.৫০',
  landType: 'কৃষি',
  ownershipType: 'ক্রয়সূত্রে',
  surveyType: 'বিআরএস',
  mutationStatus: 'completed',
  taxStatus: 'paid',
  date: '০৫ মার্চ ২০২৬',
  status: 'approved'
}, {
  id: 'APP-2026-009',
  applicant: 'রফিকুল ইসলাম',
  fatherName: 'মৃত সিরাজুল ইসলাম',
  nid: '১৯৭৬২৬৯৮৭৪৫২০',
  division: 'বরিশাল',
  district: 'বরিশাল',
  upazila: 'বাকেরগঞ্জ',
  mouza: 'বাকেরগঞ্জ',
  address: 'বাকেরগঞ্জ, বরিশাল',
  khatian: '১০৩১',
  dagNo: '৪৬৪',
  area: '০.৯০',
  landType: 'কৃষি',
  ownershipType: 'ক্রয়সূত্রে',
  surveyType: 'বিআরএস',
  mutationStatus: 'completed',
  taxStatus: 'paid',
  date: '০৪ মার্চ ২০২৬',
  status: 'rejected'
}, {
  id: 'APP-2026-010',
  applicant: 'মো. শফিকুল ইসলাম',
  fatherName: 'মৃত আনোয়ার হোসেন',
  nid: '১৯৮৪২৬৯৮৭৪৫২১',
  division: 'রংপুর',
  district: 'দিনাজপুর',
  upazila: 'বিরামপুর',
  mouza: 'বিরামপুর',
  address: 'বিরামপুর, দিনাজপুর',
  khatian: '১০৩২',
  dagNo: '৪৬৫',
  area: '২.০০',
  landType: 'কৃষি',
  ownershipType: 'উত্তরাধিকার',
  surveyType: 'বিআরএস',
  mutationStatus: 'pending',
  taxStatus: 'paid',
  date: '০৩ মার্চ ২০২৬',
  status: 'pending'
}];
export function AdminPanelPage({
  navigateTo
}: {
  navigateTo: (page: string) => void;
}) {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <DashboardView data-id="element-109" />;
      case 'applications':
        return <ApplicationsView data-id="element-110" />;
      case 'reports':
        return <div className="p-6 bg-white rounded-lg shadow-sm" data-id="element-111">
            <h2 className="text-xl font-bold mb-4" data-id="element-112">রিপোর্ট</h2>
            <p data-id="element-113">রিপোর্ট মডিউল নির্মাণাধীন...</p>
          </div>;
      case 'settings':
        return <div className="p-6 bg-white rounded-lg shadow-sm" data-id="element-114">
            <h2 className="text-xl font-bold mb-4" data-id="element-115">সেটিংস</h2>
            <p data-id="element-116">সেটিংস মডিউল নির্মাণাধীন...</p>
          </div>;
      default:
        return <DashboardView data-id="element-117" />;
    }
  };
  return <div className="min-h-screen bg-gray-100 flex font-sans" data-id="element-118">
      {/* Sidebar */}
      <aside className={`bg-[#006A4E] text-white transition-all duration-300 ${isSidebarOpen ? 'w-64' : 'w-20'} flex flex-col fixed h-full z-20`} data-id="element-119">
        <div className="h-16 flex items-center justify-center border-b border-green-800 px-4" data-id="element-120">
          {isSidebarOpen ? <div className="flex items-center gap-2" data-id="element-121">
              <img src="https://cdn.magicpatterns.com/uploads/9zTMD1Cxv4NB3L18v8BPEZ/dlrmslogo.png" alt="Logo" className="h-8 bg-white rounded p-0.5" data-id="element-122" />
              <span className="font-bold text-lg truncate" data-id="element-123">DLRMS Admin</span>
            </div> : <img src="https://cdn.magicpatterns.com/uploads/9zTMD1Cxv4NB3L18v8BPEZ/dlrmslogo.png" alt="Logo" className="h-8 bg-white rounded p-0.5" data-id="element-124" />}
        </div>

        <nav className="flex-1 py-6 space-y-2 px-3" data-id="element-125">
          <SidebarItem icon={<LayoutDashboardIcon data-id="element-127" />} label="ড্যাশবোর্ড" isActive={activeTab === 'dashboard'} onClick={() => setActiveTab('dashboard')} isOpen={isSidebarOpen} data-id="element-126" />
          <SidebarItem icon={<FileTextIcon data-id="element-129" />} label="সিএলও আবেদন সমূহ" isActive={activeTab === 'applications'} onClick={() => setActiveTab('applications')} isOpen={isSidebarOpen} data-id="element-128" />
          <SidebarItem icon={<BarChartIcon data-id="element-131" />} label="রিপোর্ট" isActive={activeTab === 'reports'} onClick={() => setActiveTab('reports')} isOpen={isSidebarOpen} data-id="element-130" />
          <SidebarItem icon={<SettingsIcon data-id="element-133" />} label="সেটিংস" isActive={activeTab === 'settings'} onClick={() => setActiveTab('settings')} isOpen={isSidebarOpen} data-id="element-132" />
        </nav>
      </aside>

      {/* Main Content */}
      <div className={`flex-1 flex flex-col transition-all duration-300 ${isSidebarOpen ? 'ml-64' : 'ml-20'}`} data-id="element-134">
        {/* Header */}
        <header className="h-16 bg-white shadow-sm flex items-center justify-between px-6 sticky top-0 z-10" data-id="element-135">
          <button onClick={() => setIsSidebarOpen(!isSidebarOpen)} className="text-gray-500 hover:text-[#006A4E]" data-id="element-136">
            <MenuIcon className="w-6 h-6" data-id="element-137" />
          </button>

          <div className="flex items-center gap-4" data-id="element-138">
            <div className="flex items-center gap-2" data-id="element-139">
              <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center text-[#006A4E]" data-id="element-140">
                <UserIcon className="w-5 h-5" data-id="element-141" />
              </div>
              <span className="font-bold text-gray-700" data-id="element-142">প্রশাসক</span>
            </div>
            <div className="w-px h-6 bg-gray-300" data-id="element-143"></div>
            <button onClick={() => navigateTo('home')} className="flex items-center gap-2 text-red-600 hover:text-red-800 font-medium text-sm" data-id="element-144">
              <LogOutIcon className="w-4 h-4" data-id="element-145" />
              লগআউট
            </button>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 p-6 overflow-auto" data-id="element-146">{renderContent()}</main>
      </div>
    </div>;
}
function SidebarItem({
  icon,
  label,
  isActive,
  onClick,
  isOpen
}: any) {
  return <button onClick={onClick} className={`w-full flex items-center gap-3 px-3 py-3 rounded-lg transition-colors ${isActive ? 'bg-green-800 text-white' : 'text-green-100 hover:bg-green-700'}`} title={!isOpen ? label : ''} data-id="element-147">
      <div className="flex-shrink-0" data-id="element-148">{icon}</div>
      {isOpen && <span className="font-medium whitespace-nowrap" data-id="element-149">{label}</span>}
    </button>;
}
function DashboardView() {
  return <div className="space-y-6" data-id="element-150">
      <h1 className="text-2xl font-bold text-gray-800" data-id="element-151">ড্যাশবোর্ড</h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-152">
        <StatCard title="মোট সিএলও আবেদন" value="১২৫" icon={<FileTextIcon className="w-8 h-8 text-blue-500" data-id="element-154" />} bg="bg-blue-50" data-id="element-153" />
        <StatCard title="অনুমোদিত" value="৮৭" icon={<CheckCircleIcon className="w-8 h-8 text-green-500" data-id="element-156" />} bg="bg-green-50" data-id="element-155" />
        <StatCard title="মুলতুবি" value="২৮" icon={<ClockIcon className="w-8 h-8 text-yellow-500" data-id="element-158" />} bg="bg-yellow-50" data-id="element-157" />
        <StatCard title="প্রত্যাখ্যাত" value="১০" icon={<XCircleIcon className="w-8 h-8 text-red-500" data-id="element-160" />} bg="bg-red-50" data-id="element-159" />
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-161">
        <h2 className="text-lg font-bold text-gray-800 mb-4" data-id="element-162">
          সাম্প্রতিক আবেদন সমূহ
        </h2>
        <div className="overflow-x-auto" data-id="element-163">
          <table className="w-full text-left border-collapse" data-id="element-164">
            <thead data-id="element-165">
              <tr className="bg-gray-50 border-b border-gray-200" data-id="element-166">
                <th className="p-3 font-bold text-gray-600 text-sm" data-id="element-167">
                  আবেদন নং
                </th>
                <th className="p-3 font-bold text-gray-600 text-sm" data-id="element-168">
                  আবেদনকারী
                </th>
                <th className="p-3 font-bold text-gray-600 text-sm" data-id="element-169">
                  খতিয়ান নং
                </th>
                <th className="p-3 font-bold text-gray-600 text-sm" data-id="element-170">তারিখ</th>
                <th className="p-3 font-bold text-gray-600 text-sm" data-id="element-171">অবস্থা</th>
              </tr>
            </thead>
            <tbody data-id="element-172">
              {sampleApplications.slice(0, 4).map((app, i) => <tr key={i} className="border-b border-gray-100 hover:bg-gray-50" data-id="element-173">
                  <td className="p-3 text-sm text-gray-800" data-id="element-174">{app.id}</td>
                  <td className="p-3 text-sm font-medium text-gray-800" data-id="element-175">
                    {app.applicant}
                  </td>
                  <td className="p-3 text-sm text-gray-600" data-id="element-176">{app.khatian}</td>
                  <td className="p-3 text-sm text-gray-600" data-id="element-177">{app.date}</td>
                  <td className="p-3" data-id="element-178">
                    <StatusBadge status={app.status} data-id="element-179" />
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}
function ApplicationsView() {
  const [selectedApp, setSelectedApp] = useState<any | null>(null);
  const [cloDataApp, setCloDataApp] = useState<any | null>(null);
  const [cloActiveTab, setCloActiveTab] = useState('overview');
  if (selectedApp) {
    return <div className="space-y-6 animate-in fade-in duration-300" data-id="element-180">
        <button onClick={() => setSelectedApp(null)} className="flex items-center text-sm font-medium text-gray-500 hover:text-[#006A4E] transition-colors" data-id="element-181">
          <ArrowLeftIcon className="w-4 h-4 mr-1" data-id="element-182" /> ফিরে যান
        </button>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 relative overflow-hidden" data-id="element-183">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-184">
            <div className="flex items-center space-x-4" data-id="element-185">
              <div className="w-16 h-16 bg-[#006A4E] rounded-xl flex items-center justify-center shadow-inner flex-shrink-0" data-id="element-186">
                <FileTextIcon className="w-8 h-8 text-white" data-id="element-187" />
              </div>
              <div data-id="element-188">
                <div className="flex items-center space-x-2 mb-1" data-id="element-189">
                  <h1 className="text-2xl font-bold text-gray-900" data-id="element-190">
                    {selectedApp.applicant}
                  </h1>
                  <StatusBadge status={selectedApp.status} data-id="element-191" />
                </div>
                <p className="text-sm text-gray-500 flex items-center" data-id="element-192">
                  <span className="font-medium text-gray-700 mr-2" data-id="element-193">
                    ID: {selectedApp.id}
                  </span>
                  <span className="mx-2 text-gray-300" data-id="element-194">|</span>
                  {selectedApp.district}, {selectedApp.upazila}
                </p>
              </div>
            </div>
            <div className="flex gap-3 w-full md:w-auto" data-id="element-195">
              <button className="px-4 py-2 bg-green-600 text-white rounded-lg font-medium hover:bg-green-700 transition-colors text-sm" data-id="element-196">
                অনুমোদন
              </button>
              <button className="px-4 py-2 bg-yellow-500 text-white rounded-lg font-medium hover:bg-yellow-600 transition-colors text-sm" data-id="element-197">
                মুলতুবি
              </button>
              <button className="px-4 py-2 bg-red-600 text-white rounded-lg font-medium hover:bg-red-700 transition-colors text-sm" data-id="element-198">
                প্রত্যাখ্যান
              </button>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-199">
          <div className="space-y-8" data-id="element-200">
            <div data-id="element-201">
              <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center border-b border-gray-100 pb-2" data-id="element-202">
                <MapPinIcon className="w-5 h-5 mr-2 text-[#006A4E]" data-id="element-203" />
                অবস্থান তথ্য
              </h3>
              <div className="bg-gray-50 rounded-xl p-5 border border-gray-100 space-y-4" data-id="element-204">
                <div className="grid grid-cols-2 gap-4" data-id="element-205">
                  <div data-id="element-206">
                    <p className="text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-207">
                      বিভাগ
                    </p>
                    <p className="font-semibold text-gray-900" data-id="element-208">
                      {selectedApp.division}
                    </p>
                  </div>
                  <div data-id="element-209">
                    <p className="text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-210">
                      জেলা
                    </p>
                    <p className="font-semibold text-gray-900" data-id="element-211">
                      {selectedApp.district}
                    </p>
                  </div>
                  <div data-id="element-212">
                    <p className="text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-213">
                      উপজেলা
                    </p>
                    <p className="font-semibold text-gray-900" data-id="element-214">
                      {selectedApp.upazila}
                    </p>
                  </div>
                  <div data-id="element-215">
                    <p className="text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-216">
                      মৌজা
                    </p>
                    <p className="font-semibold text-gray-900" data-id="element-217">
                      {selectedApp.mouza}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div data-id="element-218">
              <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center border-b border-gray-100 pb-2" data-id="element-219">
                <FileTextIcon className="w-5 h-5 mr-2 text-[#006A4E]" data-id="element-220" />
                খতিয়ানের বিবরণ
              </h3>
              <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-221">
                <div className="bg-blue-50/50 rounded-xl p-4 border border-blue-100" data-id="element-222">
                  <p className="text-xs text-blue-600 uppercase tracking-wider mb-1" data-id="element-223">
                    খতিয়ান নং
                  </p>
                  <p className="text-xl font-bold text-blue-900" data-id="element-224">
                    {selectedApp.khatian}
                  </p>
                </div>
                <div className="bg-purple-50/50 rounded-xl p-4 border border-purple-100" data-id="element-225">
                  <p className="text-xs text-purple-600 uppercase tracking-wider mb-1" data-id="element-226">
                    দাগ নং
                  </p>
                  <p className="text-xl font-bold text-purple-900" data-id="element-227">
                    {selectedApp.dagNo}
                  </p>
                </div>
              </div>

              <div className="bg-white rounded-xl border border-gray-200 shadow-sm divide-y divide-gray-100" data-id="element-228">
                <div className="p-4 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-1" data-id="element-229">
                  <span className="text-gray-500 text-sm" data-id="element-230">জরিপের ধরন</span>
                  <span className="font-semibold text-gray-900" data-id="element-231">
                    {selectedApp.surveyType}
                  </span>
                </div>
                <div className="p-4 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-1" data-id="element-232">
                  <span className="text-gray-500 text-sm" data-id="element-233">মালিকের নাম</span>
                  <span className="font-semibold text-gray-900" data-id="element-234">
                    {selectedApp.applicant}
                  </span>
                </div>
                <div className="p-4 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-1" data-id="element-235">
                  <span className="text-gray-500 text-sm" data-id="element-236">পিতার নাম</span>
                  <span className="font-semibold text-gray-900" data-id="element-237">
                    {selectedApp.fatherName}
                  </span>
                </div>
                <div className="p-4 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-1" data-id="element-238">
                  <span className="text-gray-500 text-sm" data-id="element-239">ঠিকানা</span>
                  <span className="font-semibold text-gray-900 text-right" data-id="element-240">
                    {selectedApp.address}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-8" data-id="element-241">
            <div data-id="element-242">
              <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center border-b border-gray-100 pb-2" data-id="element-243">
                <ShieldCheckIcon className="w-5 h-5 mr-2 text-[#006A4E]" data-id="element-244" />
                সম্পত্তির অবস্থা
              </h3>
              <div className="bg-white rounded-xl border border-gray-200 shadow-sm divide-y divide-gray-100" data-id="element-245">
                <div className="p-4 flex justify-between items-center" data-id="element-246">
                  <span className="text-gray-600 font-medium" data-id="element-247">জমির ধরন</span>
                  <span className="px-3 py-1 bg-gray-100 text-gray-800 rounded-full text-sm font-semibold" data-id="element-248">
                    {selectedApp.landType}
                  </span>
                </div>
                <div className="p-4 flex justify-between items-center" data-id="element-249">
                  <span className="text-gray-600 font-medium" data-id="element-250">জমির পরিমাণ</span>
                  <span className="font-bold text-gray-900" data-id="element-251">
                    {selectedApp.area} একর
                  </span>
                </div>
                <div className="p-4 flex justify-between items-center" data-id="element-252">
                  <span className="text-gray-600 font-medium" data-id="element-253">
                    মালিকানার ধরন
                  </span>
                  <span className="font-semibold text-gray-900" data-id="element-254">
                    {selectedApp.ownershipType}
                  </span>
                </div>
                <div className="p-4 flex justify-between items-center" data-id="element-255">
                  <span className="text-gray-600 font-medium" data-id="element-256">
                    নামজারি অবস্থা
                  </span>
                  <span className={`px-3 py-1 rounded-full text-sm font-semibold flex items-center ${selectedApp.mutationStatus === 'completed' ? 'bg-green-100 text-green-800' : 'bg-amber-100 text-amber-800'}`} data-id="element-257">
                    {selectedApp.mutationStatus === 'completed' && <CheckCircleIcon className="w-3.5 h-3.5 mr-1" data-id="element-258" />}
                    {selectedApp.mutationStatus === 'completed' ? 'সম্পন্ন' : 'প্রক্রিয়াধীন'}
                  </span>
                </div>
                <div className="p-4 flex justify-between items-center" data-id="element-259">
                  <span className="text-gray-600 font-medium" data-id="element-260">
                    ভূমি উন্নয়ন কর অবস্থা
                  </span>
                  <span className={`px-3 py-1 rounded-full text-sm font-semibold ${selectedApp.taxStatus === 'paid' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`} data-id="element-261">
                    {selectedApp.taxStatus === 'paid' ? 'পরিশোধিত' : 'বকেয়া'}
                  </span>
                </div>
              </div>
            </div>

            <div data-id="element-262">
              <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center border-b border-gray-100 pb-2" data-id="element-263">
                <AlertCircleIcon className="w-5 h-5 mr-2 text-[#006A4E]" data-id="element-264" />
                আবেদন তথ্য
              </h3>
              <div className="bg-white rounded-xl border border-gray-200 shadow-sm divide-y divide-gray-100" data-id="element-265">
                <div className="p-4 flex justify-between items-center" data-id="element-266">
                  <span className="text-gray-600 font-medium" data-id="element-267">
                    আবেদনের তারিখ
                  </span>
                  <span className="font-bold text-gray-900" data-id="element-268">
                    {selectedApp.date}
                  </span>
                </div>
                <div className="p-4 flex justify-between items-center" data-id="element-269">
                  <span className="text-gray-600 font-medium" data-id="element-270">
                    জাতীয় পরিচয়পত্র নং
                  </span>
                  <span className="font-bold text-gray-900" data-id="element-271">
                    {selectedApp.nid}
                  </span>
                </div>
                <div className="p-4 flex justify-between items-center" data-id="element-272">
                  <span className="text-gray-600 font-medium" data-id="element-273">
                    বর্তমান অবস্থা
                  </span>
                  <StatusBadge status={selectedApp.status} data-id="element-274" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>;
  }
  if (cloDataApp) {
    const cloTabs = [{
      id: 'overview',
      label: 'সারসংক্ষেপ',
      icon: FileTextIcon
    }, {
      id: 'mutation',
      label: 'নামজারি তথ্য',
      icon: FileTextIcon
    }, {
      id: 'tax',
      label: 'এলডি ট্যাক্স তথ্য',
      icon: CreditCardIcon
    }, {
      id: 'parcelMap',
      label: 'পার্সেল মানচিত্র',
      icon: MapIcon
    }, {
      id: 'transferHistory',
      label: 'হস্তান্তর বৃত্তান্ত',
      icon: HistoryIcon
    }, {
      id: 'disputes',
      label: 'মামলা তথ্য',
      icon: GavelIcon
    }, {
      id: 'mortgages',
      label: 'বন্ধক তথ্য',
      icon: BuildingIcon
    }];
    return <div className="space-y-6 max-w-7xl mx-auto animate-in fade-in duration-300 pb-24" data-id="element-275">
        <button onClick={() => {
        setCloDataApp(null);
        setCloActiveTab('overview');
      }} className="flex items-center text-sm font-medium text-gray-500 hover:text-[#006A4E] transition-colors" data-id="element-276">
          <ArrowLeftIcon className="w-4 h-4 mr-1" data-id="element-277" /> ফিরে যান
        </button>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 relative overflow-hidden" data-id="element-278">
          <div className="flex items-center space-x-4" data-id="element-279">
            <div className="w-16 h-16 bg-[#006A4E] rounded-xl flex items-center justify-center shadow-inner flex-shrink-0" data-id="element-280">
              <DatabaseIcon className="w-8 h-8 text-white" data-id="element-281" />
            </div>
            <div data-id="element-282">
              <h1 className="text-2xl font-bold text-gray-900 mb-1" data-id="element-283">
                সিএলও তথ্য যোগ - {cloDataApp.id}
              </h1>
              <p className="text-sm text-gray-500" data-id="element-284">
                আবেদনকারী: {cloDataApp.applicant} | খতিয়ান:{' '}
                {cloDataApp.khatian}
              </p>
            </div>
          </div>
        </div>

        <form onSubmit={e => {
        e.preventDefault();
        alert('সিএলও তথ্য সফলভাবে সংরক্ষিত হয়েছে!');
        setCloDataApp(null);
        setCloActiveTab('overview');
      }} data-id="element-285">
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden flex flex-col md:flex-row min-h-[600px]" data-id="element-286">
            {/* Tabs Sidebar */}
            <div className="w-full md:w-64 bg-gray-50 border-b md:border-b-0 md:border-r border-gray-200 flex-shrink-0" data-id="element-287">
              <div className="flex md:flex-col overflow-x-auto md:overflow-visible hide-scrollbar p-2 md:p-4 gap-1" data-id="element-288">
                {cloTabs.map(tab => {
                const Icon = tab.icon;
                const isActive = cloActiveTab === tab.id;
                return <button key={tab.id} type="button" onClick={() => setCloActiveTab(tab.id)} className={`flex items-center space-x-3 px-4 py-3 rounded-lg text-sm font-medium whitespace-nowrap transition-all ${isActive ? 'bg-[#006A4E] text-white shadow-md' : 'text-gray-600 hover:bg-gray-200 hover:text-gray-900'}`} data-id="element-289">
                      <Icon className={`w-5 h-5 ${isActive ? 'text-green-100' : 'text-gray-400'}`} data-id="element-290" />
                      <span data-id="element-291">{tab.label}</span>
                    </button>;
              })}
              </div>
            </div>

            {/* Tab Content */}
            <div className="flex-1 p-6 md:p-8 overflow-y-auto bg-white" data-id="element-292">
              {/* TAB 1: OVERVIEW */}
              {cloActiveTab === 'overview' && <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 animate-in fade-in duration-300" data-id="element-293">
                  <div className="space-y-8" data-id="element-294">
                    <div data-id="element-295">
                      <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center border-b border-gray-100 pb-2" data-id="element-296">
                        <MapPinIcon className="w-5 h-5 mr-2 text-[#006A4E]" data-id="element-297" />
                        অবস্থান তথ্য
                      </h3>
                      <div className="bg-gray-50 rounded-xl p-5 border border-gray-100" data-id="element-298">
                        <div className="grid grid-cols-2 gap-4" data-id="element-299">
                          <div data-id="element-300">
                            <label className="block text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-301">
                              বিভাগ
                            </label>
                            <select className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#006A4E] focus:border-transparent bg-white text-sm" defaultValue={cloDataApp.division} data-id="element-302">
                              <option value="ঢাকা" data-id="element-303">ঢাকা</option>
                              <option value="চট্টগ্রাম" data-id="element-304">চট্টগ্রাম</option>
                              <option value="রাজশাহী" data-id="element-305">রাজশাহী</option>
                            </select>
                          </div>
                          <div data-id="element-306">
                            <label className="block text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-307">
                              জেলা
                            </label>
                            <select className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#006A4E] focus:border-transparent bg-white text-sm" defaultValue={cloDataApp.district} data-id="element-308">
                              <option value={cloDataApp.district} data-id="element-309">
                                {cloDataApp.district}
                              </option>
                              <option value="গাজীপুর" data-id="element-310">গাজীপুর</option>
                            </select>
                          </div>
                          <div data-id="element-311">
                            <label className="block text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-312">
                              উপজেলা
                            </label>
                            <select className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#006A4E] focus:border-transparent bg-white text-sm" defaultValue={cloDataApp.upazila} data-id="element-313">
                              <option value={cloDataApp.upazila} data-id="element-314">
                                {cloDataApp.upazila}
                              </option>
                              <option value="পল্লবী" data-id="element-315">পল্লবী</option>
                            </select>
                          </div>
                          <div data-id="element-316">
                            <label className="block text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-317">
                              মৌজা
                            </label>
                            <input type="text" defaultValue={cloDataApp.mouza} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#006A4E] focus:border-transparent text-sm" data-id="element-318" />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div data-id="element-319">
                      <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center border-b border-gray-100 pb-2" data-id="element-320">
                        <FileTextIcon className="w-5 h-5 mr-2 text-[#006A4E]" data-id="element-321" />
                        খতিয়ানের বিবরণ
                      </h3>
                      <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-322">
                        <div className="bg-blue-50/50 rounded-xl p-4 border border-blue-100" data-id="element-323">
                          <label className="block text-xs text-blue-600 uppercase tracking-wider mb-1" data-id="element-324">
                            খতিয়ান নং
                          </label>
                          <input type="text" defaultValue={cloDataApp.khatian} className="w-full px-3 py-2 border border-blue-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg font-bold text-blue-900 bg-white" data-id="element-325" />
                        </div>
                        <div className="bg-purple-50/50 rounded-xl p-4 border border-purple-100" data-id="element-326">
                          <label className="block text-xs text-purple-600 uppercase tracking-wider mb-1" data-id="element-327">
                            দাগ নং
                          </label>
                          <input type="text" defaultValue={cloDataApp.dagNo} className="w-full px-3 py-2 border border-purple-200 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-lg font-bold text-purple-900 bg-white" data-id="element-328" />
                        </div>
                      </div>

                      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-4 space-y-4" data-id="element-329">
                        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2" data-id="element-330">
                          <label className="text-gray-600 text-sm font-medium w-1/3" data-id="element-331">
                            জরিপের ধরন
                          </label>
                          <select className="w-full sm:w-2/3 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#006A4E] focus:border-transparent text-sm" defaultValue={cloDataApp.surveyType} data-id="element-332">
                            <option value="বিআরএস" data-id="element-333">বিআরএস</option>
                            <option value="সিএস" data-id="element-334">সিএস</option>
                            <option value="এসএ" data-id="element-335">এসএ</option>
                            <option value="আরএস" data-id="element-336">আরএস</option>
                          </select>
                        </div>
                        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2" data-id="element-337">
                          <label className="text-gray-600 text-sm font-medium w-1/3" data-id="element-338">
                            মালিকের নাম
                          </label>
                          <input type="text" defaultValue={cloDataApp.applicant} className="w-full sm:w-2/3 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#006A4E] focus:border-transparent text-sm" data-id="element-339" />
                        </div>
                        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2" data-id="element-340">
                          <label className="text-gray-600 text-sm font-medium w-1/3" data-id="element-341">
                            পিতার নাম
                          </label>
                          <input type="text" defaultValue={cloDataApp.fatherName} className="w-full sm:w-2/3 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#006A4E] focus:border-transparent text-sm" data-id="element-342" />
                        </div>
                        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2" data-id="element-343">
                          <label className="text-gray-600 text-sm font-medium w-1/3" data-id="element-344">
                            ঠিকানা
                          </label>
                          <input type="text" defaultValue={cloDataApp.address} className="w-full sm:w-2/3 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#006A4E] focus:border-transparent text-sm" data-id="element-345" />
                        </div>
                        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2" data-id="element-346">
                          <label className="text-gray-600 text-sm font-medium w-1/3" data-id="element-347">
                            জাতীয় পরিচয়পত্র নং
                          </label>
                          <input type="text" defaultValue={cloDataApp.nid} className="w-full sm:w-2/3 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#006A4E] focus:border-transparent text-sm" data-id="element-348" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="space-y-8" data-id="element-349">
                    <div data-id="element-350">
                      <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center border-b border-gray-100 pb-2" data-id="element-351">
                        <ShieldCheckIcon className="w-5 h-5 mr-2 text-[#006A4E]" data-id="element-352" />
                        সম্পত্তির অবস্থা
                      </h3>
                      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-4 space-y-4" data-id="element-353">
                        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2" data-id="element-354">
                          <label className="text-gray-600 text-sm font-medium w-1/3" data-id="element-355">
                            জমির ধরন
                          </label>
                          <select className="w-full sm:w-2/3 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#006A4E] focus:border-transparent text-sm" defaultValue={cloDataApp.landType} data-id="element-356">
                            <option value="কৃষি" data-id="element-357">কৃষি</option>
                            <option value="আবাসিক" data-id="element-358">আবাসিক</option>
                            <option value="বাণিজ্যিক" data-id="element-359">বাণিজ্যিক</option>
                          </select>
                        </div>
                        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2" data-id="element-360">
                          <label className="text-gray-600 text-sm font-medium w-1/3" data-id="element-361">
                            জমির পরিমাণ
                          </label>
                          <div className="w-full sm:w-2/3 flex items-center gap-2" data-id="element-362">
                            <input type="text" defaultValue={cloDataApp.area} className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#006A4E] focus:border-transparent text-sm" data-id="element-363" />
                            <span className="text-gray-500 text-sm font-medium" data-id="element-364">
                              একর
                            </span>
                          </div>
                        </div>
                        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2" data-id="element-365">
                          <label className="text-gray-600 text-sm font-medium w-1/3" data-id="element-366">
                            মালিকানার ধরন
                          </label>
                          <select className="w-full sm:w-2/3 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#006A4E] focus:border-transparent text-sm" defaultValue={cloDataApp.ownershipType} data-id="element-367">
                            <option value="ক্রয়সূত্রে" data-id="element-368">ক্রয়সূত্রে</option>
                            <option value="উত্তরাধিকার" data-id="element-369">উত্তরাধিকার</option>
                            <option value="দানপত্র" data-id="element-370">দানপত্র</option>
                          </select>
                        </div>
                        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2" data-id="element-371">
                          <label className="text-gray-600 text-sm font-medium w-1/3" data-id="element-372">
                            নামজারি অবস্থা
                          </label>
                          <select className="w-full sm:w-2/3 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#006A4E] focus:border-transparent text-sm" defaultValue={cloDataApp.mutationStatus === 'completed' ? 'সম্পন্ন' : 'প্রক্রিয়াধীন'} data-id="element-373">
                            <option value="সম্পন্ন" data-id="element-374">সম্পন্ন</option>
                            <option value="প্রক্রিয়াধীন" data-id="element-375">প্রক্রিয়াধীন</option>
                          </select>
                        </div>
                        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2" data-id="element-376">
                          <label className="text-gray-600 text-sm font-medium w-1/3" data-id="element-377">
                            ভূমি কর অবস্থা
                          </label>
                          <select className="w-full sm:w-2/3 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#006A4E] focus:border-transparent text-sm" defaultValue={cloDataApp.taxStatus === 'paid' ? 'পরিশোধিত' : 'বকেয়া'} data-id="element-378">
                            <option value="পরিশোধিত" data-id="element-379">পরিশোধিত</option>
                            <option value="বকেয়া" data-id="element-380">বকেয়া</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>}

              {/* TAB 2: MUTATION */}
              {cloActiveTab === 'mutation' && <div className="animate-in fade-in duration-300 space-y-6" data-id="element-381">
                  <h3 className="text-xl font-bold text-gray-900 mb-6 border-b border-gray-100 pb-2 flex items-center" data-id="element-382">
                    <FileTextIcon className="w-6 h-6 mr-2 text-[#006A4E]" data-id="element-383" />
                    নামজারি তথ্য
                  </h3>

                  <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden" data-id="element-384">
                    <div className="bg-gray-50 px-6 py-3 border-b border-gray-200 flex justify-between items-center" data-id="element-385">
                      <span className="font-bold text-gray-700 flex items-center" data-id="element-386">
                        <FileTextIcon className="w-4 h-4 mr-2 text-[#006A4E]" data-id="element-387" />
                        রেকর্ড #1
                      </span>
                      <button type="button" className="text-red-500 hover:text-red-700 text-sm font-medium" data-id="element-388">
                        মুছে ফেলুন
                      </button>
                    </div>
                    <div className="p-6 grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-389">
                      <div data-id="element-390">
                        <label className="block text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-391">
                          তারিখ
                        </label>
                        <input type="date" defaultValue="2025-05-15" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#006A4E] focus:border-transparent text-sm" data-id="element-392" />
                      </div>
                      <div data-id="element-393">
                        <label className="block text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-394">
                          হস্তান্তরকারী
                        </label>
                        <input type="text" defaultValue="আব্দুল কুদ্দুস" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#006A4E] focus:border-transparent text-sm" data-id="element-395" />
                      </div>
                      <div data-id="element-396">
                        <label className="block text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-397">
                          গ্রহীতা
                        </label>
                        <input type="text" defaultValue={cloDataApp.applicant} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#006A4E] focus:border-transparent text-sm" data-id="element-398" />
                      </div>
                      <div data-id="element-399">
                        <label className="block text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-400">
                          হস্তান্তরের ধরন
                        </label>
                        <select className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#006A4E] focus:border-transparent text-sm" defaultValue="ক্রয়" data-id="element-401">
                          <option value="ক্রয়" data-id="element-402">ক্রয়</option>
                          <option value="উত্তরাধিকার" data-id="element-403">উত্তরাধিকার</option>
                          <option value="দান" data-id="element-404">দান</option>
                        </select>
                      </div>
                      <div data-id="element-405">
                        <label className="block text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-406">
                          মামলা নং
                        </label>
                        <input type="text" defaultValue="MUT-2025-892" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#006A4E] focus:border-transparent text-sm" data-id="element-407" />
                      </div>
                      <div data-id="element-408">
                        <label className="block text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-409">
                          মামলার তারিখ
                        </label>
                        <input type="date" defaultValue="2025-04-10" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#006A4E] focus:border-transparent text-sm" data-id="element-410" />
                      </div>
                      <div data-id="element-411">
                        <label className="block text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-412">
                          অনুমোদনের তারিখ
                        </label>
                        <input type="date" defaultValue="2025-05-12" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#006A4E] focus:border-transparent text-sm" data-id="element-413" />
                      </div>
                      <div data-id="element-414">
                        <label className="block text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-415">
                          ডিসিআর নং
                        </label>
                        <input type="text" defaultValue="DCR-88921" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#006A4E] focus:border-transparent text-sm" data-id="element-416" />
                      </div>
                      <div data-id="element-417">
                        <label className="block text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-418">
                          ডিসিআর তারিখ
                        </label>
                        <input type="date" defaultValue="2025-05-15" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#006A4E] focus:border-transparent text-sm" data-id="element-419" />
                      </div>
                    </div>
                  </div>

                  <button type="button" className="flex items-center justify-center w-full py-3 border-2 border-dashed border-[#006A4E] text-[#006A4E] rounded-xl font-bold hover:bg-green-50 transition-colors" data-id="element-420">
                    <PlusIcon className="w-5 h-5 mr-2" data-id="element-421" />
                    নতুন নামজারি রেকর্ড যোগ করুন
                  </button>
                </div>}

              {/* TAB 3: TAX */}
              {cloActiveTab === 'tax' && <div className="animate-in fade-in duration-300 space-y-6" data-id="element-422">
                  <h3 className="text-xl font-bold text-gray-900 mb-6 border-b border-gray-100 pb-2 flex items-center" data-id="element-423">
                    <CreditCardIcon className="w-6 h-6 mr-2 text-[#006A4E]" data-id="element-424" />
                    এলডি ট্যাক্স তথ্য
                  </h3>

                  <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden" data-id="element-425">
                    <div className="overflow-x-auto" data-id="element-426">
                      <table className="w-full text-left text-sm" data-id="element-427">
                        <thead className="bg-gray-50 text-gray-600 font-medium border-b border-gray-200" data-id="element-428">
                          <tr data-id="element-429">
                            <th className="px-4 py-3" data-id="element-430">অর্থবছর</th>
                            <th className="px-4 py-3" data-id="element-431">পরিমাণ</th>
                            <th className="px-4 py-3" data-id="element-432">অবস্থা</th>
                            <th className="px-4 py-3" data-id="element-433">দাখিলা নং</th>
                            <th className="px-4 py-3" data-id="element-434">দাখিলার তারিখ</th>
                            <th className="px-4 py-3 w-10" data-id="element-435"></th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-100" data-id="element-436">
                          <tr data-id="element-437">
                            <td className="px-4 py-3" data-id="element-438">
                              <input type="text" defaultValue="২০২৫-২০২৬" className="w-full px-2 py-1.5 border border-gray-300 rounded focus:ring-1 focus:ring-[#006A4E]" data-id="element-439" />
                            </td>
                            <td className="px-4 py-3" data-id="element-440">
                              <input type="text" defaultValue="৳ ৫০০" className="w-full px-2 py-1.5 border border-gray-300 rounded focus:ring-1 focus:ring-[#006A4E]" data-id="element-441" />
                            </td>
                            <td className="px-4 py-3" data-id="element-442">
                              <select className="w-full px-2 py-1.5 border border-gray-300 rounded focus:ring-1 focus:ring-[#006A4E]" defaultValue="পরিশোধিত" data-id="element-443">
                                <option value="পরিশোধিত" data-id="element-444">পরিশোধিত</option>
                                <option value="বকেয়া" data-id="element-445">বকেয়া</option>
                              </select>
                            </td>
                            <td className="px-4 py-3" data-id="element-446">
                              <input type="text" defaultValue="DKH-2026-001" className="w-full px-2 py-1.5 border border-gray-300 rounded focus:ring-1 focus:ring-[#006A4E]" data-id="element-447" />
                            </td>
                            <td className="px-4 py-3" data-id="element-448">
                              <input type="text" defaultValue="১৫ জানুয়ারি ২০২৬" className="w-full px-2 py-1.5 border border-gray-300 rounded focus:ring-1 focus:ring-[#006A4E]" data-id="element-449" />
                            </td>
                            <td className="px-4 py-3 text-center" data-id="element-450">
                              <button type="button" className="text-red-500 hover:text-red-700" data-id="element-451">
                                <XCircleIcon className="w-5 h-5" data-id="element-452" />
                              </button>
                            </td>
                          </tr>
                          <tr data-id="element-453">
                            <td className="px-4 py-3" data-id="element-454">
                              <input type="text" defaultValue="২০২৪-২০২৫" className="w-full px-2 py-1.5 border border-gray-300 rounded focus:ring-1 focus:ring-[#006A4E]" data-id="element-455" />
                            </td>
                            <td className="px-4 py-3" data-id="element-456">
                              <input type="text" defaultValue="৳ ৪৫০" className="w-full px-2 py-1.5 border border-gray-300 rounded focus:ring-1 focus:ring-[#006A4E]" data-id="element-457" />
                            </td>
                            <td className="px-4 py-3" data-id="element-458">
                              <select className="w-full px-2 py-1.5 border border-gray-300 rounded focus:ring-1 focus:ring-[#006A4E]" defaultValue="পরিশোধিত" data-id="element-459">
                                <option value="পরিশোধিত" data-id="element-460">পরিশোধিত</option>
                                <option value="বকেয়া" data-id="element-461">বকেয়া</option>
                              </select>
                            </td>
                            <td className="px-4 py-3" data-id="element-462">
                              <input type="text" defaultValue="DKH-2025-001" className="w-full px-2 py-1.5 border border-gray-300 rounded focus:ring-1 focus:ring-[#006A4E]" data-id="element-463" />
                            </td>
                            <td className="px-4 py-3" data-id="element-464">
                              <input type="text" defaultValue="২০ জানুয়ারি ২০২৫" className="w-full px-2 py-1.5 border border-gray-300 rounded focus:ring-1 focus:ring-[#006A4E]" data-id="element-465" />
                            </td>
                            <td className="px-4 py-3 text-center" data-id="element-466">
                              <button type="button" className="text-red-500 hover:text-red-700" data-id="element-467">
                                <XCircleIcon className="w-5 h-5" data-id="element-468" />
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <button type="button" className="flex items-center justify-center w-full py-3 border-2 border-dashed border-[#006A4E] text-[#006A4E] rounded-xl font-bold hover:bg-green-50 transition-colors" data-id="element-469">
                    <PlusIcon className="w-5 h-5 mr-2" data-id="element-470" />
                    নতুন ট্যাক্স রেকর্ড যোগ করুন
                  </button>
                </div>}

              {/* TAB 4: PARCEL MAP */}
              {cloActiveTab === 'parcelMap' && <div className="animate-in fade-in duration-300 space-y-6" data-id="element-471">
                  <h3 className="text-xl font-bold text-gray-900 mb-6 border-b border-gray-100 pb-2 flex items-center" data-id="element-472">
                    <MapIcon className="w-6 h-6 mr-2 text-[#006A4E]" data-id="element-473" />
                    পার্সেল মানচিত্র
                  </h3>

                  <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm" data-id="element-474">
                    <div className="border-2 border-dashed border-gray-300 rounded-xl p-12 flex flex-col items-center justify-center bg-gray-50 hover:bg-gray-100 transition-colors cursor-pointer mb-6" data-id="element-475">
                      <UploadIcon className="w-12 h-12 text-gray-400 mb-4" data-id="element-476" />
                      <p className="text-lg font-bold text-gray-700 mb-1" data-id="element-477">
                        মানচিত্র আপলোড করুন
                      </p>
                      <p className="text-sm text-gray-500" data-id="element-478">
                        JPG, PNG ফাইল সমর্থিত (সর্বোচ্চ ৫ MB)
                      </p>
                    </div>

                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 bg-gray-50 p-5 rounded-xl border border-gray-100" data-id="element-479">
                      <div data-id="element-480">
                        <p className="text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-481">
                          খতিয়ান
                        </p>
                        <p className="text-lg font-bold text-gray-900" data-id="element-482">
                          {cloDataApp.khatian}
                        </p>
                      </div>
                      <div data-id="element-483">
                        <p className="text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-484">
                          দাগ
                        </p>
                        <p className="text-lg font-bold text-gray-900" data-id="element-485">
                          {cloDataApp.dagNo}
                        </p>
                      </div>
                      <div data-id="element-486">
                        <p className="text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-487">
                          মৌজা
                        </p>
                        <p className="text-lg font-bold text-gray-900" data-id="element-488">
                          {cloDataApp.mouza}
                        </p>
                      </div>
                      <div data-id="element-489">
                        <p className="text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-490">
                          পরিমাণ
                        </p>
                        <p className="text-lg font-bold text-gray-900" data-id="element-491">
                          {cloDataApp.area} একর
                        </p>
                      </div>
                    </div>
                  </div>
                </div>}

              {/* TAB 5: TRANSFER HISTORY */}
              {cloActiveTab === 'transferHistory' && <div className="animate-in fade-in duration-300 space-y-6" data-id="element-492">
                  <h3 className="text-xl font-bold text-gray-900 mb-6 border-b border-gray-100 pb-2 flex items-center" data-id="element-493">
                    <HistoryIcon className="w-6 h-6 mr-2 text-[#006A4E]" data-id="element-494" />
                    হস্তান্তর বৃত্তান্ত
                  </h3>

                  <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden" data-id="element-495">
                    <div className="bg-[#4CAF50] text-white text-center py-3 font-bold text-lg" data-id="element-496">
                      হস্তান্তর বৃত্তান্ত
                    </div>
                    <div className="overflow-x-auto p-4" data-id="element-497">
                      <table className="w-full text-center text-sm border-collapse" data-id="element-498">
                        <thead className="bg-gray-50 text-gray-800 font-medium" data-id="element-499">
                          <tr data-id="element-500">
                            <th className="px-2 py-3 border border-gray-200" data-id="element-501">
                              আগত খতিয়ান নং
                            </th>
                            <th className="px-2 py-3 border border-gray-200" data-id="element-502">
                              দাগ নং
                            </th>
                            <th className="px-2 py-3 border border-gray-200" data-id="element-503">
                              দাগে জমির পরিমান (একর)
                            </th>
                            <th className="px-2 py-3 border border-gray-200" data-id="element-504">
                              খতিয়ানে জমির পরিমাণ (একর)
                            </th>
                            <th className="px-2 py-3 border border-gray-200" data-id="element-505">
                              হস্তান্তরিত জমির পরিমাণ (একর)
                            </th>
                          </tr>
                        </thead>
                        <tbody data-id="element-506">
                          <tr data-id="element-507">
                            <td className="px-2 py-2 border border-gray-200" data-id="element-508">
                              <input type="text" defaultValue="৯৮০" className="w-full px-2 py-1.5 border border-gray-300 rounded text-center focus:ring-1 focus:ring-[#006A4E]" data-id="element-509" />
                            </td>
                            <td className="px-2 py-2 border border-gray-200" data-id="element-510">
                              <input type="text" defaultValue={cloDataApp.dagNo} className="w-full px-2 py-1.5 border border-gray-300 rounded text-center focus:ring-1 focus:ring-[#006A4E]" data-id="element-511" />
                            </td>
                            <td className="px-2 py-2 border border-gray-200" data-id="element-512">
                              <input type="text" defaultValue="১.২০" className="w-full px-2 py-1.5 border border-gray-300 rounded text-center focus:ring-1 focus:ring-[#006A4E]" data-id="element-513" />
                            </td>
                            <td className="px-2 py-2 border border-gray-200" data-id="element-514">
                              <input type="text" defaultValue="২.৫০" className="w-full px-2 py-1.5 border border-gray-300 rounded text-center focus:ring-1 focus:ring-[#006A4E]" data-id="element-515" />
                            </td>
                            <td className="px-2 py-2 border border-gray-200" data-id="element-516">
                              <input type="text" defaultValue={cloDataApp.area} className="w-full px-2 py-1.5 border border-gray-300 rounded text-center focus:ring-1 focus:ring-[#006A4E] font-bold" data-id="element-517" />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="border-t border-gray-200 p-4 space-y-4 bg-gray-50" data-id="element-518">
                      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4" data-id="element-519">
                        <label className="font-bold text-gray-800 w-full sm:w-1/4" data-id="element-520">
                          মালিকানা সূত্র:
                        </label>
                        <input type="text" defaultValue="ক্রয় সূত্রে" className="w-full sm:w-3/4 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#006A4E]" data-id="element-521" />
                      </div>
                      <div className="flex flex-col sm:flex-row items-start gap-4" data-id="element-522">
                        <label className="font-bold text-gray-800 w-full sm:w-1/4 pt-2" data-id="element-523">
                          বিবরণ:
                        </label>
                        <textarea rows={3} placeholder="বিস্তারিত বিবরণ লিখুন..." className="w-full sm:w-3/4 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#006A4E]" data-id="element-524"></textarea>
                      </div>
                    </div>
                  </div>

                  <button type="button" className="flex items-center justify-center w-full py-3 border-2 border-dashed border-[#006A4E] text-[#006A4E] rounded-xl font-bold hover:bg-green-50 transition-colors" data-id="element-525">
                    <PlusIcon className="w-5 h-5 mr-2" data-id="element-526" />
                    নতুন হস্তান্তর রেকর্ড যোগ করুন
                  </button>
                </div>}

              {/* TAB 6: DISPUTES */}
              {cloActiveTab === 'disputes' && <div className="animate-in fade-in duration-300 space-y-6" data-id="element-527">
                  <h3 className="text-xl font-bold text-gray-900 mb-6 border-b border-gray-100 pb-2 flex items-center" data-id="element-528">
                    <GavelIcon className="w-6 h-6 mr-2 text-[#006A4E]" data-id="element-529" />
                    মামলা তথ্য
                  </h3>

                  <div className="text-center py-16 bg-green-50 rounded-xl border border-green-200" data-id="element-530">
                    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-531">
                      <CheckCircleIcon className="w-8 h-8 text-green-600" data-id="element-532" />
                    </div>
                    <h4 className="text-lg font-bold text-green-900 mb-2" data-id="element-533">
                      কোন মামলা নেই
                    </h4>
                    <p className="text-green-700 mb-6" data-id="element-534">
                      এই সম্পত্তির জন্য কোন সক্রিয় মামলা বা বিবাদ পাওয়া
                      যায়নি।
                    </p>
                    <button type="button" className="px-6 py-2.5 bg-white border border-green-600 text-green-700 rounded-lg font-medium hover:bg-green-100 transition-colors inline-flex items-center" data-id="element-535">
                      <PlusIcon className="w-4 h-4 mr-2" data-id="element-536" /> মামলা যোগ করুন
                    </button>
                  </div>
                </div>}

              {/* TAB 7: MORTGAGES */}
              {cloActiveTab === 'mortgages' && <div className="animate-in fade-in duration-300 space-y-6" data-id="element-537">
                  <h3 className="text-xl font-bold text-gray-900 mb-6 border-b border-gray-100 pb-2 flex items-center" data-id="element-538">
                    <BuildingIcon className="w-6 h-6 mr-2 text-[#006A4E]" data-id="element-539" />
                    বন্ধক তথ্য
                  </h3>

                  <div className="text-center py-16 bg-gray-50 rounded-xl border border-gray-200 border-dashed" data-id="element-540">
                    <BuildingIcon className="w-12 h-12 text-gray-300 mx-auto mb-3" data-id="element-541" />
                    <p className="text-gray-500 font-medium mb-6" data-id="element-542">
                      কোন বন্ধক রেকর্ড পাওয়া যায়নি।
                    </p>
                    <button type="button" className="px-6 py-2.5 bg-white border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-100 transition-colors inline-flex items-center" data-id="element-543">
                      <PlusIcon className="w-4 h-4 mr-2" data-id="element-544" /> বন্ধক যোগ করুন
                    </button>
                  </div>
                </div>}
            </div>
          </div>

          {/* Sticky Footer Actions */}
          <div className="fixed bottom-0 right-0 left-0 md:left-64 bg-white border-t border-gray-200 p-4 px-6 flex justify-end gap-4 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)] z-30 transition-all duration-300" data-id="element-545">
            <button type="button" onClick={() => {
            setCloDataApp(null);
            setCloActiveTab('overview');
          }} className="px-6 py-2.5 border border-gray-300 text-gray-700 rounded-lg font-bold hover:bg-gray-50 transition-colors" data-id="element-546">
              বাতিল
            </button>
            <button type="submit" className="px-8 py-2.5 bg-[#006A4E] text-white rounded-lg font-bold hover:bg-[#004D3A] transition-colors flex items-center gap-2 shadow-sm" data-id="element-547">
              <DatabaseIcon className="w-5 h-5" data-id="element-548" />
              সিএলও তথ্য সংরক্ষণ করুন
            </button>
          </div>
        </form>
      </div>;
  }
  return <div className="space-y-6 animate-in fade-in duration-300" data-id="element-549">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-550">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-551">সিএলও আবেদন সমূহ</h1>
        <div className="relative w-full sm:w-64" data-id="element-552">
          <SearchIcon className="w-5 h-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-553" />
          <input type="text" placeholder="আবেদন খুঁজুন..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#006A4E] focus:border-transparent" data-id="element-554" />
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-555">
        <div className="overflow-x-auto" data-id="element-556">
          <table className="w-full text-left border-collapse" data-id="element-557">
            <thead data-id="element-558">
              <tr className="bg-gray-50 border-b border-gray-200" data-id="element-559">
                <th className="p-4 font-bold text-gray-600 text-sm" data-id="element-560">ক্রমিক</th>
                <th className="p-4 font-bold text-gray-600 text-sm" data-id="element-561">
                  আবেদন নং
                </th>
                <th className="p-4 font-bold text-gray-600 text-sm" data-id="element-562">
                  আবেদনকারী
                </th>
                <th className="p-4 font-bold text-gray-600 text-sm" data-id="element-563">
                  খতিয়ান নং
                </th>
                <th className="p-4 font-bold text-gray-600 text-sm" data-id="element-564">মৌজা</th>
                <th className="p-4 font-bold text-gray-600 text-sm" data-id="element-565">তারিখ</th>
                <th className="p-4 font-bold text-gray-600 text-sm" data-id="element-566">অবস্থা</th>
                <th className="p-4 font-bold text-gray-600 text-sm text-right" data-id="element-567">
                  অ্যাকশন
                </th>
              </tr>
            </thead>
            <tbody data-id="element-568">
              {sampleApplications.map((app, i) => <tr key={i} className="border-b border-gray-100 hover:bg-gray-50 transition-colors" data-id="element-569">
                  <td className="p-4 text-sm text-gray-600" data-id="element-570">{i + 1}</td>
                  <td className="p-4 text-sm font-medium text-[#006A4E]" data-id="element-571">
                    {app.id}
                  </td>
                  <td className="p-4 text-sm font-bold text-gray-800" data-id="element-572">
                    {app.applicant}
                  </td>
                  <td className="p-4 text-sm text-gray-600" data-id="element-573">{app.khatian}</td>
                  <td className="p-4 text-sm text-gray-600" data-id="element-574">{app.mouza}</td>
                  <td className="p-4 text-sm text-gray-600" data-id="element-575">{app.date}</td>
                  <td className="p-4" data-id="element-576">
                    <StatusBadge status={app.status} data-id="element-577" />
                  </td>
                  <td className="p-4 text-right" data-id="element-578">
                    <div className="flex justify-end gap-3" data-id="element-579">
                      <button onClick={() => setSelectedApp(app)} className="flex items-center gap-1 text-sm font-medium text-[#1976D2] hover:underline" data-id="element-580">
                        <EyeIcon className="w-4 h-4" data-id="element-581" /> বিস্তারিত
                      </button>
                      <button onClick={() => setCloDataApp(app)} className="flex items-center gap-1 text-sm font-medium text-[#006A4E] hover:underline" data-id="element-582">
                        <DatabaseIcon className="w-4 h-4" data-id="element-583" /> সিএলও তথ্য
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="p-4 border-t border-gray-200 flex justify-between items-center text-sm text-gray-600" data-id="element-584">
          <span data-id="element-585">মোট ১০ টি আবেদন দেখানো হচ্ছে</span>
          <div className="flex gap-1" data-id="element-586">
            <button className="px-3 py-1 border border-gray-300 rounded hover:bg-gray-50" data-id="element-587">
              পূর্ববর্তী
            </button>
            <button className="px-3 py-1 bg-[#006A4E] text-white rounded" data-id="element-588">
              ১
            </button>
            <button className="px-3 py-1 border border-gray-300 rounded hover:bg-gray-50" data-id="element-589">
              পরবর্তী
            </button>
          </div>
        </div>
      </div>
    </div>;
}
function StatCard({
  title,
  value,
  icon,
  bg
}: any) {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 flex items-center gap-4" data-id="element-590">
      <div className={`w-16 h-16 rounded-full flex items-center justify-center ${bg}`} data-id="element-591">
        {icon}
      </div>
      <div data-id="element-592">
        <p className="text-sm font-bold text-gray-500 mb-1" data-id="element-593">{title}</p>
        <h3 className="text-3xl font-extrabold text-gray-800" data-id="element-594">{value}</h3>
      </div>
    </div>;
}
function StatusBadge({
  status
}: {
  status: string;
}) {
  if (status === 'approved') {
    return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-595">
        অনুমোদিত
      </span>;
  }
  if (status === 'pending') {
    return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800" data-id="element-596">
        মুলতুবি
      </span>;
  }
  return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800" data-id="element-597">
      প্রত্যাখ্যাত
    </span>;
}